import type { ReactNode, MouseEvent } from "react";
import { Lock } from "lucide-react";
import { useLocation } from "wouter";
import type { MembersContent } from "@workspace/api-client-react";
import { confirmAdultAccess } from "./AdultContentToggle";

type Props = {
  item: Pick<MembersContent, "isAdult">;
  href: string;
  className?: string;
  children: ReactNode;
};

export function AdultLockOverlay() {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/25 pointer-events-none">
      <div className="flex items-center gap-2 rounded-full border border-white/30 bg-black/70 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-white backdrop-blur-sm">
        <Lock className="h-3.5 w-3.5 text-red-300" />
        18+ · Verify to view
      </div>
    </div>
  );
}

export function AdultLockedLink({ item, href, className, children }: Props) {
  const [, navigate] = useLocation();

  async function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    if (!item.isAdult) return;
    event.preventDefault();
    if (await confirmAdultAccess()) navigate(href);
  }

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}